"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPatientInfoMachine = exports.makeConfig = exports.machineJSON = void 0;
const xstate_1 = require("xstate");
const api_1 = require("../../lib/api");
const Actions_1 = require("../../lib/constants/Actions");
const States_1 = require("../../lib/constants/States");
const covidVaccineUtils_1 = require("../../lib/covidVaccineUtils");
const gxUtils_1 = require("../../lib/gxUtils");
const utils_1 = require("../../lib/utils");
const actions = {
    setPatientRegistration: (0, xstate_1.assign)({
        patientRegistration: (_ctx, ev) => ev.data.patientRegistration
    }),
    sendParentNext: (0, xstate_1.sendParent)((ctx) => ({
        type: Actions_1.NEXT,
        data: {
            patientRegistration: ctx.patientRegistration,
            isCaptchaVerified: ctx.isCaptchaVerified,
            bookedAppt: ctx.bookedAppt,
            waitlistStatus: ctx.waitlistStatus
        }
    })),
    updateFields: (0, xstate_1.assign)({
        updatedFields: (_ctx, ev) => ev.data.updatedFields
    }),
    saveFieldsToParent: (0, xstate_1.sendParent)((ctx) => ({
        type: Actions_1.FORM_UPDATE,
        data: {
            updatedFields: ctx.updatedFields
        }
    })),
    setIsCaptchaVerified: (0, xstate_1.assign)((_ctx, ev) => ({
        isCaptchaVerified: ev.data
    })),
    setSelectedPatientIndex: (0, xstate_1.assign)((_ctx, ev) => ({
        selectedPatientIndex: ev.data.patientIndex
    })),
    setCurrentPatientEhrDemographics: (0, xstate_1.assign)({
        ehrPatientList: (ctx, ev) => {
            const updatedPatientList = [...ctx.ehrPatientList];
            updatedPatientList[ctx.selectedPatientIndex].demographics = ev.data;
            return updatedPatientList;
        }
    }),
    handleEhrPatientDemographicLoadFailure: (0, xstate_1.assign)(() => ({
        selectedPatientIndex: null
    })),
    blankOutForm: (0, xstate_1.assign)(() => ({
        updatedFields: {}
    })),
    setPatientRegFormFromApi: (0, xstate_1.assign)((_ctx, ev) => {
        return { patientRegForm: ev.data };
    }),
    setPatientRegFormFromContext: (0, xstate_1.assign)((ctx) => {
        const { covidVaccinePatientRegFormConfig, patientRegFormConfig, provider } = ctx;
        if ((0, covidVaccineUtils_1.isCovidVaccineProvider)(provider) && covidVaccinePatientRegFormConfig) {
            return { patientRegForm: covidVaccinePatientRegFormConfig };
        }
        else {
            return { patientRegForm: patientRegFormConfig };
        }
    }),
    setBookedAppt: (0, xstate_1.assign)({
        bookedAppt: (ctx, event) => event.data.result
    }),
    sendParentRebook: (0, xstate_1.sendParent)(() => ({
        type: Actions_1.REBOOK
    })),
    setJoinWaitlistSuccessResponse: (0, xstate_1.assign)({
        waitlistStatus: (_ctx, _ev) => {
            var _a;
            return Object.assign({ success: true }, (_a = _ev.data) === null || _a === void 0 ? void 0 : _a.result);
        }
    }),
    setJoinWaitlistStatusFailed: (0, xstate_1.assign)({
        waitlistStatus: (_ctx, _ev) => {
            return {
                success: false,
                error: true
            };
        }
    }),
    // Add waitlist-specific actions
    setWaitlistOptInField: (0, xstate_1.assign)({
        waitlist: (context, event) => (Object.assign(Object.assign({}, context.waitlist), { optIn: event.data.optIn, errors: event.data.errors || [] }))
    }),
    updateWaitlistMobileNumberField: (0, xstate_1.assign)({
        waitlist: (context, event) => (Object.assign(Object.assign({}, context.waitlist), { mobileNumber: event.data.mobileNumber || '', errors: event.data.errors || [] }))
    }),
    updateWaitlistMobileNumberFieldErrors: (0, xstate_1.assign)({
        waitlist: (context, event) => (Object.assign(Object.assign({}, context.waitlist), { errors: event.data.errors || [] }))
    })
};
const guards = {
    isCaptchaNotVerifiedCtx: (ctx) => {
        return !ctx.isCaptchaVerified;
    },
    isCaptchaNotVerifiedSession: (_ctx, ev) => {
        return !ev.data;
    },
    checkIsPatientDemographicAlreadyLoaded: (ctx, ev) => {
        return !!ctx.ehrPatientList[ev.data.patientIndex].demographics;
    },
    checkWasSomebodyElseSelected: (_ctx, ev) => {
        return ev.data.patientIndex === null;
    },
    checkIfEHRAndMainPatientLoaded: (ctx) => {
        return ctx.ehr && ctx.ehrPatientList && ctx.ehrPatientList.length > 0;
    },
    checkIfEHRWithoutDropdownAndMainPatientLoaded: (ctx) => {
        return (ctx.ehr &&
            !ctx.ehr.show_dropdown &&
            ctx.ehrPatientList &&
            ctx.ehrPatientList.length > 0);
    },
    // needed?
    checkIfEHRButMainPatientDidNotLoad: (ctx) => {
        return ctx.ehr && (!ctx.ehrPatientList || ctx.ehrPatientList.length == 0);
    },
    receivedValidPatientRegForm: (_ctx, ev) => {
        return (0, utils_1.isValidPatientRegForm)(ev.data);
    },
    hasValidPatientRegFormInContext: (ctx) => {
        return (0, utils_1.isValidPatientRegForm)(ctx.patientRegForm);
    },
    isBookingDuplicate: (_ctx, e) => {
        const body = e.data.response.data;
        return body.error && body.error.code === 'SLOT_UNAVAILABLE';
    },
    didBookingFail: (_ctx, event) => !event.data || !event.data.result,
    hasJoinedWaitlist: (ctx, _event) => {
        var _a;
        return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.waitlist) === null || _a === void 0 ? void 0 : _a.optIn;
    }
};
const services = {
    getEhrPatientDemographics: (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const { ehrPatientList, services, customerCode, productName, apiBaseURL } = ctx;
        const { pid, pid_type, source_system } = ehrPatientList[ctx.selectedPatientIndex].patient_ids[0];
        const api = new api_1.Api({ customerCode, productName, apiBaseURL });
        const demographics = yield api.getEhrPatientDemographics(services.getEhrPatientDemographics, {
            pid,
            pid_type,
            source_system
        });
        if (!demographics) {
            throw new Error('Failed to load patient demographics');
        }
        return demographics;
    }),
    checkCaptchaVerified: (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const { customerCode, productName, apiBaseURL } = ctx;
        const api = new api_1.Api({ customerCode, productName, apiBaseURL });
        const res = yield api.checkCaptcha();
        return res.verified;
    }),
    fetchPatientRegFormForProvider: (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const { services, provider } = ctx;
        const res = yield services.getPatientRegForm(provider.id);
        return res;
    }),
    handleBookAppt: (ctx) => {
        const { customerCode, productName, apiBaseURL } = ctx;
        const api = new api_1.Api({ customerCode, productName, apiBaseURL });
        const ehrBoundGXData = (0, gxUtils_1.getGXDataForEHR)(ctx.linkedGxAnswers);
        return api.bookAppointment({
            csrfToken: ctx.csrfToken,
            selectedAppointment: ctx.selectedAppointment,
            patientRegistration: ctx.patientRegistration,
            ehrBoundGXData,
            channel: ctx.productName,
            appointmentEhrId: ctx.appointmentEhrId
        });
    },
    handleJoinWaitlist: (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const { services } = ctx;
        const response = yield services.createAppointmentWaitList({
            appointment_entity_id: ctx.bookedAppt['appointment_ehr_id'],
            patient_contact_phone: ctx.waitlist.mobileNumber,
            consent_for_contact: ctx.waitlist.optIn,
            claim_from_waitlist_base_url: window.location.origin
        });
        return response.data;
    })
};
const machineJSON = ({ provider, insuranceOptions, appointmentQuery, selectedAppointment, updatedFields, covidVaccinePatientRegFormConfig, patientRegFormConfig, isCaptchaVerified, ehr, ehrPatientList, selectedPatientIndex, services, customerCode, csrfToken, linkedGxAnswers, productName, featureFlags, appointmentEhrId, apiBaseURL, waitlist }) => ({
    id: `Machine__${States_1.patientInfo}`,
    type: 'parallel',
    context: {
        provider,
        insuranceOptions,
        appointmentQuery,
        selectedAppointment,
        updatedFields,
        covidVaccinePatientRegFormConfig,
        patientRegFormConfig,
        isCaptchaVerified,
        patientRegistration: null,
        ehr,
        ehrPatientList,
        selectedPatientIndex,
        ehrLoadFailure: false,
        services,
        customerCode,
        csrfToken,
        location: (0, utils_1.getApptLocation)(provider, selectedAppointment),
        bookedAppt: null,
        linkedGxAnswers,
        productName,
        featureFlags,
        appointmentEhrId,
        apiBaseURL,
        waitlist
    },
    on: {
        [Actions_1.SET_WAITLIST_OPTIN_STATUS_FIELD]: {
            actions: 'setWaitlistOptInField'
        },
        [Actions_1.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD]: {
            actions: 'updateWaitlistMobileNumberField'
        },
        [Actions_1.UPDATE_WAITLIST_MOBILE_NUMBER_FIELD_ERRORS]: {
            actions: 'updateWaitlistMobileNumberFieldErrors'
        }
    },
    states: {
        [States_1.ehrData]: {
            initial: States_1.routing,
            states: {
                [States_1.routing]: {
                    always: [
                        {
                            cond: 'checkIfEHRButMainPatientDidNotLoad',
                            target: States_1.ehrMainFailed
                        },
                        {
                            cond: 'checkIfEHRWithoutDropdownAndMainPatientLoaded',
                            target: States_1.ehrFormNoDropdown
                        },
                        {
                            cond: 'checkIfEHRAndMainPatientLoaded',
                            target: States_1.ehrForm
                        },
                        {
                            target: States_1.freeform
                        }
                    ]
                },
                [States_1.ehrForm]: {
                    on: {
                        [Actions_1.SELECT_PATIENT]: [
                            {
                                cond: 'checkWasSomebodyElseSelected',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrSomebodyElseForm
                            },
                            {
                                cond: 'checkIsPatientDemographicAlreadyLoaded',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrForm
                            },
                            {
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.pendingEhrPatientDemographics
                            }
                        ]
                    }
                },
                [States_1.ehrFormNoDropdown]: {},
                [States_1.ehrFormRelatedFailed]: {
                    on: {
                        [Actions_1.SELECT_PATIENT]: [
                            // Guaranteed to only have main and 'Someone Else', only one transition available
                            {
                                cond: 'checkWasSomebodyElseSelected',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrSomebodyElseFormRelatedFailed
                            }
                        ]
                    }
                },
                [States_1.ehrSomebodyElseForm]: {
                    on: {
                        [Actions_1.SELECT_PATIENT]: [
                            {
                                cond: 'checkWasSomebodyElseSelected',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrSomebodyElseForm
                            },
                            {
                                cond: 'checkIsPatientDemographicAlreadyLoaded',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrForm
                            },
                            {
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.pendingEhrPatientDemographics
                            }
                        ]
                    }
                },
                [States_1.ehrSomebodyElseFormRelatedFailed]: {
                    on: {
                        [Actions_1.SELECT_PATIENT]: [
                            // Guaranteed to only have main and 'Someone Else', only one transition available
                            {
                                cond: 'checkIsPatientDemographicAlreadyLoaded',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrFormRelatedFailed
                            }
                        ]
                    }
                },
                [States_1.ehrMainFailed]: {},
                [States_1.ehrSubFailed]: {
                    on: {
                        [Actions_1.SELECT_PATIENT]: [
                            {
                                cond: 'checkWasSomebodyElseSelected',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrSomebodyElseForm
                            },
                            {
                                cond: 'checkIsPatientDemographicAlreadyLoaded',
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.ehrForm
                            },
                            {
                                actions: ['setSelectedPatientIndex', 'blankOutForm'],
                                target: States_1.pendingEhrPatientDemographics
                            }
                        ]
                    }
                },
                [States_1.freeform]: {},
                [States_1.pendingEhrPatientDemographics]: {
                    invoke: {
                        id: 'getEhrPatientDemographics',
                        src: 'getEhrPatientDemographics',
                        onDone: {
                            actions: 'setCurrentPatientEhrDemographics',
                            target: States_1.ehrForm
                        },
                        onError: {
                            actions: 'handleEhrPatientDemographicLoadFailure',
                            target: States_1.ehrSubFailed
                        }
                    }
                }
            }
        },
        [States_1.patientForm]: {
            initial: States_1.fetchingPatientRegForm,
            states: {
                [States_1.fetchingPatientRegForm]: {
                    invoke: {
                        id: 'fetchPatientRegFormForProvider',
                        src: 'fetchPatientRegFormForProvider',
                        onDone: [
                            {
                                cond: 'receivedValidPatientRegForm',
                                actions: 'setPatientRegFormFromApi',
                                target: [States_1.verifyingPatientRegForm]
                            },
                            {
                                actions: 'setPatientRegFormFromContext',
                                target: [States_1.verifyingPatientRegForm]
                            }
                        ],
                        onError: {
                            actions: 'setPatientRegFormFromContext',
                            target: [States_1.verifyingPatientRegForm]
                        }
                    }
                },
                [States_1.verifyingPatientRegForm]: {
                    always: [
                        {
                            cond: 'hasValidPatientRegFormInContext',
                            target: [States_1.dataEntry]
                        },
                        { target: [States_1.error] }
                    ]
                },
                [States_1.dataEntry]: {
                    on: {
                        [Actions_1.FORM_CHANGE]: {
                            actions: ['updateFields', 'saveFieldsToParent']
                        },
                        [Actions_1.BOOK_APPT]: [
                            {
                                cond: 'isCaptchaNotVerifiedCtx',
                                target: States_1.checkingCaptchaSession,
                                actions: ['setPatientRegistration']
                            },
                            {
                                target: States_1.bookingAppt,
                                actions: ['setPatientRegistration']
                            }
                        ]
                    }
                },
                [States_1.checkingCaptchaSession]: {
                    invoke: {
                        id: 'checkingCaptchaVerified',
                        src: 'checkCaptchaVerified',
                        onDone: [
                            { cond: 'isCaptchaNotVerifiedSession', target: States_1.verifyingCaptcha },
                            {
                                actions: ['setIsCaptchaVerified', 'sendParentNext']
                            }
                        ],
                        onError: States_1.verifyingCaptcha
                    }
                },
                [States_1.verifyingCaptcha]: {
                    on: {
                        [Actions_1.CAPTCHA_CANCELLED]: {
                            target: States_1.dataEntry
                        },
                        [Actions_1.CAPTCHA_VERIFIED]: {
                            target: States_1.dataEntry,
                            actions: ['setIsCaptchaVerified', 'sendParentNext']
                        },
                        [Actions_1.CAPTCHA_ERROR]: {
                            target: States_1.verifyingCaptchaError
                        }
                    }
                },
                [States_1.verifyingCaptchaError]: {
                    on: {
                        [Actions_1.CAPTCHA_RESET]: {
                            target: States_1.verifyingCaptcha
                        },
                        [Actions_1.CAPTCHA_CANCELLED]: {
                            target: States_1.dataEntry
                        }
                    }
                },
                [States_1.bookingAppt]: {
                    invoke: {
                        id: 'handleBookAppt',
                        src: 'handleBookAppt',
                        onDone: [
                            {
                                cond: 'didBookingFail',
                                target: States_1.error
                            },
                            {
                                cond: 'hasJoinedWaitlist',
                                actions: 'setBookedAppt',
                                target: States_1.joinWaitlist
                            },
                            {
                                actions: ['setBookedAppt'],
                                target: States_1.success
                            }
                        ],
                        onError: [
                            {
                                cond: 'isBookingDuplicate',
                                target: States_1.apptUnavailable
                            },
                            { target: States_1.error }
                        ]
                    }
                },
                [States_1.apptUnavailable]: {
                    initial: States_1.error,
                    states: {
                        [States_1.error]: {
                            after: {
                                5000: States_1.redirecting
                            },
                            on: {
                                [Actions_1.REBOOK_DIRECT]: States_1.redirecting
                            }
                        },
                        [States_1.redirecting]: {
                            entry: 'sendParentRebook'
                        }
                    }
                },
                [States_1.joinWaitlist]: {
                    invoke: {
                        id: 'joinWaitlist',
                        src: 'handleJoinWaitlist',
                        onDone: [
                            {
                                actions: ['setJoinWaitlistSuccessResponse'],
                                target: States_1.success
                            }
                        ],
                        onError: {
                            actions: 'setJoinWaitlistStatusFailed',
                            target: States_1.success
                        }
                    }
                },
                [States_1.success]: {
                    entry: 'sendParentNext'
                },
                [States_1.error]: {
                    on: {
                        [Actions_1.BOOK_APPT]: States_1.bookingAppt
                    }
                }
            }
        }
    }
});
exports.machineJSON = machineJSON;
const makeConfig = () => ({ actions, guards, services });
exports.makeConfig = makeConfig;
const createPatientInfoMachine = (_a) => {
    var { config = (0, exports.makeConfig)() } = _a, props = __rest(_a, ["config"]);
    return (0, xstate_1.Machine)((0, exports.machineJSON)(props)).withConfig(config);
};
exports.createPatientInfoMachine = createPatientInfoMachine;
//# sourceMappingURL=patientInfo.js.map